(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from "react";
import PropTypes from "prop-types";
export const LeftArrow = _ref => {
  let {
    className,
    color
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    color: color,
    width: "12",
    height: "10",
    viewBox: "0 0 11 10",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 5H1.5",
    stroke: "#6D849B",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 1.5L1 5L4.5 8.5",
    stroke: "#6D849B",
    strokeWidth: "1.5",
    strokeLinejoin: "round"
  }));
};
LeftArrow.defaultProps = {
  className: null,
  color: "#6D849B"
};
LeftArrow.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string
};
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(LeftArrow, "LeftArrow", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/icons/LeftArrow.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();